module.exports = __webpack_public_path__ + "static/media/direito.71857f4b.jpg";